import React from 'react'
import BannerBG from '../components/BannerComponents/BannerBG'
import Banner from '../components/BannerComponents/Banner';
import { Link } from 'react-router-dom';

export default function Error(){
  return (
    <BannerBG>
      <Banner title='404' subtitle='Page Not Found'>
        <Link to='/' className='btn-primary'>
          Return Home
        </Link>
      </Banner>
    </BannerBG>
  )
}
